export default {
  /**
   * 必須項目チェック
   */
  required: (value) => !!value || value === 0 || '必ず入力してください',
  /**
   * 文字数チェック
   */
  limitLength: function (limit) {
    return (value) => !value || value.length <= limit || `${limit}文字以内で入力してください`;
  },
  /**
   * 数値チェック
   */
  numeric: (value) => !value || /^[-]?([1-9]\d*|0)$/.test(value) || '数値を入力してください',
  /**
   * 検証実行
   */
  validate: function (value, rules, name) {
    let results = [];
    rules.forEach(function (rule) {
      let result = rule(value);
      // console.log(`value: ${value} rule: ${rule} result: ${result}`);
      if (result !== true) results.push(`${name} ${result}`);
    });
    return results;
  },
};
